import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton } from 'element-ui';

export default {
    name: 'RaceRegistrationListFilter',
    props: {
        filter: Object,
        ageGroups: Array
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    watch: {
        perPage: {
            immediate: true,
            handler() {
                var options = { ...this.filter.options };
                var filter = { ...this.filter };

                filter.options = options;
                filter.options.perPage = this.perPage;
                this.$emit("update:filter", filter);
            },
        },
        status: {
            immediate: true,
            handler() {
                var filter = { ...this.filter };

                filter.status = this.status;
                this.$emit("update:filter", filter);
            }
        },
        ageGroup: {
            immediate: true,
            handler() {
                var filter = { ...this.filter };

                filter.ageGroup = this.ageGroup;
                this.$emit("update:filter", filter);
            }
        },
        gender: {
            immediate: true,
            handler() {
                var filter = { ...this.filter };

                filter.gender = this.gender;
                this.$emit("update:filter", filter);
            }
        },
        isParatriathlete: {
            immediate: true,
            handler() {
                var filter = { ...this.filter };
                
                filter.isParatriathlete = this.isParatriathlete;
                this.$emit("update:filter", filter);
            }
        },
        isTransfer: {
            immediate: true,
            handler() {
                var filter = { ...this.filter };

                filter.isTransfer = this.isTransfer;
                this.$emit("update:filter", filter);
            }
        }
    },
    data() {
        return {
            isProcessing: false,
            perPage: 5,
            perPageOptions: [5, 10, 25, 50, 100],
            userName: null,
            userId: null,
            searchData: null,
            status: null,
            ageGroup: 0,
            gender: 0,
            isParatriathlete: null,
            isTransfer: null
        }
    },
    computed: { },
    methods: {
        userSearchChange() {
            let filter = { ...this.filter };

            if (Number(this.searchData) > 0) {
                filter.userId = this.searchData;
                filter.userName = null;
            }
            else {
                filter.userId = null;
                filter.userName = this.searchData;
            }

            this.$emit("update:filter", filter);
        }
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-registration/filter-bar/filter-bar.js